import { Component, Input, OnInit } from '@angular/core';
import { SafeResourceUrl } from '@angular/platform-browser';
import { ModalController, NavParams } from '@ionic/angular';

@Component({
  selector: 'app-document-visualizer',
  templateUrl: './document-visualizer.component.html',
  styleUrls: ['./document-visualizer.component.scss'],
})
export class DocumentVisualizerComponent  implements OnInit {
  
  documentUrl: SafeResourceUrl | null = null;
  url: string | null = null;
  filename: string | null = null;

  constructor(private modalCtrl: ModalController,
    public navParams: NavParams,
  ) { }

  ngOnInit() {
    this.documentUrl = this.navParams.get('documentUrl');
    this.url = this.navParams.get('url');
    this.filename = this.navParams.get('filename');
  }

  cancel() {
    return this.modalCtrl.dismiss(null, 'cancel');
  }

  /**
   *
   */
  downloadPDF() {
    const link = document.createElement('a');
    link.href = this.url;
    link.download = this.filename+'.pdf';
    link.click();
    window.URL.revokeObjectURL(this.url);
  }

}
